import React from 'react';
import { i18n } from '@guuru/translation-web';
import { SelectInput, TargetOption } from '../../../SelectInput';

interface TransferTargetsProps {
  targets: {
    id: number;
    title: string;
  }[];
  // eslint-disable-next-line no-unused-vars
  setFieldsValue: (_: { target: string }) => void;
  // eslint-disable-next-line no-unused-vars
  onChange?: (_: string) => void;
}

const TransferTargets = function ({
  targets,
  setFieldsValue,
  onChange = () => {},
}: TransferTargetsProps) {
  return (
    <SelectInput
      labelInValue
      aria-label={i18n.t('chat:::selectTargetSmartForm')}
      placeholder={i18n.t('chat:::selectTargetSmartForm')}
      onChange={(option) => {
        const selected = option as React.ComponentProps<typeof TargetOption>;
        setFieldsValue({ target: selected.value });
        onChange(selected.value);
      }}
    >
      {targets?.map((target) => (
        <TargetOption key={target.id} value={target.id}>
          {target.title}
        </TargetOption>
      ))}
    </SelectInput>
  );
};

export default TransferTargets;
